export const buildMonthlyData = (data) => {
    const result = Array(12).fill(0);
  
    data.forEach((item) => {
      result[item.month - 1] = Number(item.count);
    });
  
    return result;
  };
  
  export const buildChartLabels = (
    data,
    key
  ) => data.map((item) => item[key]);
  
  export const buildChartValues = (data) =>
    data.map((item) => Number(item.count));